export const vacancies = [
  {
    id: 1,
    title: "Администратор на ресепшн с выездом",
    status: "closed",
    description: "Работа с выездом на объекты гостиничных комплексов. Приём и размещение гостей, работа с кассой, координация работы горничных и технической службы.",
    requirements: ["Опыт от 1 года", "Знание PMS-систем", "Готовность к командировкам", "Знание английского языка"],
  },
  {
    id: 2,
    title: "Удалённый администратор",
    status: "open",
    description: "Удалённая работа с бронированиями, коммуникация с гостями через мессенджеры и телефон, работа в CRM Битрикс24, ведение отчётности.",
    requirements: ["Опыт не обязателен", "Грамотная речь", "Уверенный пользователь ПК", "Обучаемость"],
  },
  {
    id: 3,
    title: "Менеджер по продажам",
    status: "closed",
    description: "Продажа дополнительных услуг гостиничных комплексов, работа с входящими заявками, консультирование клиентов по тарифам и спецпредложениям.",
    requirements: ["Опыт в продажах от 1 года", "Навыки переговоров", "Знание техник продаж", "Опыт в HoReCa будет преимуществом"],
  },
  {
    id: 4,
    title: "Специалист Call-центра",
    status: "open",
    description: "Приём входящих звонков от гостей, обработка запросов на бронирование, консультирование по услугам отелей-партнёров, работа со скриптами.",
    requirements: ["Грамотная устная и письменная речь", "Стрессоустойчивость", "Многозадачность", "Опыт работы в колл-центре приветствуется"],
  },
];